"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentCol = exports.ToggleButton = exports.Wrapper = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;
exports.ToggleButton = styled_components_1.default.button `
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  height: 25px;
  width: 25px;
`;
exports.ContentCol = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: hidden;
`;
//# sourceMappingURL=style.js.map